import React from 'react';
import { Construction } from 'lucide-react';
import Breadcrumbs from '../../common/Breadcrumbs';
import './SettingsDetail.css';

/**
 * Coming Soon placeholder component for unimplemented settings
 * @param {Object} props
 * @param {string} props.title - Setting title
 * @param {string} props.description - Setting description
 * @param {Array<{label: string, path?: string}>} props.breadcrumbItems - Breadcrumb items
 * @param {React.ComponentType} props.icon - Icon component (optional)
 */
const ComingSoon = ({ title, description, breadcrumbItems, icon: Icon }) => {
  return (
    <div className="settings-detail">
      <Breadcrumbs items={breadcrumbItems} />

      <div className="settings-detail-container">
        <div className="settings-detail-header">
          <div className="settings-detail-header-icon">
            {Icon ? <Icon size={26} /> : <Construction size={26} />}
          </div>
          <div>
            <h1 className="settings-detail-title">{title}</h1>
            <p className="settings-detail-description">{description}</p>
          </div>
        </div>

        <div className="settings-card-detail">
          <div className="settings-coming-soon">
            <div className="settings-coming-soon-icon">
              <Construction size={32} />
            </div>
            <h2>Coming Soon</h2>
            <p>This feature is currently under development and will be available soon.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ComingSoon;
